import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.scss";
import ShipmentTracker from "./views/ShipmentTracker";

const PageNotFound = lazy(() => import("./views/404"));

const TRACKER_PATHS = [
  "/",
  "/ecommerce-tracking",
  "/track-order/:trackingId",
  "/customer-tracking-web-page/:trackingId",
  "/:trackingId",
];

const App = () => (
  <BrowserRouter basename="/">
    <Suspense fallback={null}>
      <Routes>
        {TRACKER_PATHS.map((path) => (
          <Route key={path} path={path} element={<ShipmentTracker />} />
        ))}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Suspense>
  </BrowserRouter>
);

export default App;
